import './App.css';
import Main from './Components/Layout/Main';
import Head from './Components/Layout/Head';
import Footer from './Components/Layout/Footer';
import {
  Routes,
  Route
} from "react-router-dom";
import BinomialTheorem from './Components/Posts/BinomialTheorem/BinomialTheorem';
import Feb232023 from './Components/Posts/BinomialTheorem/Feb252023/Feb252023';



function App() {
  return (
    <div className="App">
      <Head className="main-head" />
    <Routes>
     <Route path='/' element={<Main/>}>
      <Route index element={<Feb232023 />} />
      <Route path='binomial' element={<BinomialTheorem />} />
     </Route>
    </Routes>
    <Footer />
    </div>
  );
}

export default App;
